export async function fetchRefreshedToken(apiDomain, brokerConfigId, token) {
    const domain = apiDomain ? apiDomain : TIMEOUTWIDGET_API_DOMAIN;
    const path = brokerConfigId ? `${REFRESH_TOKEN_URL}?brokerConfigId=${brokerConfigId}` : REFRESH_TOKEN_URL;
    const url = `${domain}${path}`;

    let data = null;

    try {
        const response = await fetch(url, {
            method: 'GET',
            headers: {
                'Authorization': token,
                'Content-Type': 'application/json'
            }
        });

        if (response.ok) {
            data = await response.json();
        }
        else {
            // Handel error response from service
            const errorData = await response.json();
            console.log('Timeout Widget: Error response from token refresh service', errorData.Message);
        }
    } catch (error) {
        // Handel network error
        console.log('Timeout Widget: Network error with token refresh service', error.message, error.stack);
    }

    return data;
}